<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 120px">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">PPN Masukan</span></h5>
                  <h3 class="my-3">
                    <span>{{ totalSaldoTax + totalPPNMasukan + totalPPNMasukanSaldo | currency}}</span>
                    <!-- {{ totalSaldoTax | currency }} {{ totalPPNMasukan | currency }} {{ totalPPNMasukanSaldo | currency }} -->
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">PPN Keluaran</span></h5>
                  <h3 class="my-3">
                      <span>{{ totalPPNKeluaranSale | currency}}</span>
                      <!-- <span>{{ totalTaxSales | currency}}</span> -->
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-success">Payment PPN</span></h5>
                  <h3 class="my-3">
                    <span>{{ (totalSaldoTax + totalPPNMasukan + totalPPNMasukanSaldo) - totalPPNKeluaranSale | currency }}</span>
                    <!-- <span>{{ (totalSaldoTax + totalPPNMasukan + totalPPNMasukanSaldo) - totalTaxSales | currency }}</span> -->
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">Total PPN Payment Journal</span></h5>
                  <h3 class="my-3">
                    {{ paymentPPN | currency }}
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Saldo</span></h5>
                <h3 class="my-3">
                  <span>{{ totalSaldoTax | currency }}</span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">PPN Masukan</span></h5>
                  <h3 class="my-3">
                    {{ totalPPNMasukan | currency }}
                  </h3>
                </div>
              </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                    <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">PPN Masukan (m-1)</span></h5>
                <h3 class="my-3">
                  {{ totalPPNMasukanSaldo | currency }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                    <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total PPN Masukan</span></h5>
                <h3 class="my-3">
                  {{ totalSaldoTax + totalPPNMasukan + totalPPNMasukanSaldo | currency }}
                </h3>
              </div>
            </div>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">Sisa PPN Masukan (Akumulasi)</span></h5>
                  <h3 class="my-3">
                    {{ totalAllPPNMasukanRemaning | currency }}
                    <!-- ({{ this.totalPPNMasukanRemaning | currency }} | {{ this.totalTaxPurchasingSaldo | currency }} | {{ this.totalPPNMasukanSaldo | currency }}) -->
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">Sisa PPN Keluaran (Akumulasi)</span></h5>
                  <h3 class="my-3">
                    {{ totalAllPPNKeluaranRemaning | currency }}
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">Total Sisa PPN</span></h5>
                  <h3 class="my-3">
                    {{ totalAllPPNMasukanRemaning - totalAllPPNKeluaranRemaning | currency }}
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-info">Sisa PPN Setelah Order</span></h5>
                  <h3 class="my-3">
                      <span>{{ (totalAllPPNMasukanRemaning - totalAllPPNKeluaranRemaning) + (purchasingOrderTaxOutstanding - saleOrderTaxOutstanding) | currency}}</span>
                  </h3>
                </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-warning">Order PPN Masukan</span></h5>
                  <h3 class="my-3">
                      <span>{{ purchasingOrderTaxOutstanding | currency}}</span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-warning">Order PPN Keluaran</span></h5>
                  <h3 class="my-3">
                      <span>{{ saleOrderTaxOutstanding | currency}}</span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
              <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Oustanding Order PPN</span></h5>
              <h3 class="my-3">
                <span>{{ purchasingOrderTaxOutstanding - saleOrderTaxOutstanding  | currency }}</span>
              </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-warning">Total Sisa PPN Masukan m-1</span></h5>
                  <h3 class="my-3">
                      <span>{{ totalTaxPurchasingSaldo | currency}}</span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <div class="col-md-3">
              <div class="card report-card">
                  <div class="card-body">
                  <div class="float-right">
                      <i class="dripicons-user-group report-main-icon"></i>
                  </div>
                  <h5><span class="badge badge-warning">Total Sisa PPN Keluaran m-1</span></h5>
                  <h3 class="my-3">
                      <span>{{ totalTaxSalesSaldo | currency}}</span>
                  </h3>
                  </div>
                  <!--end card-body-->
              </div>
              <!--end card-->
          </div>
          <!-- <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
              <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Outstanding PPN Masukan</span></h5>
              <h3 class="my-3">
                <span>{{ outstandingMasukan | currency }}</span>
              </h3>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Tax Monitoring</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect ml-2" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary ml-2" data-toggle="modal" data-target="#modalTaxSaldo" data-backdrop="static" data-keyboard="false">
                            <i class="fa fa-plus"></i> Add Saldo
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary ml-2" data-toggle="modal" data-target="#modalTaxSaldoList" data-backdrop="static" data-keyboard="false" @click="getSaldo">Saldo List</button>
                          <!-- <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('sales')">PDF</a>
                          </div> -->
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf', 'tax')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf', 'saldo')">PDF Saldo</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel', 'tax')">Excel</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel', 'saldo')">Excel Saldo</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <!-- <li class="nav-item"><a href="#report-tax-monitoring" data-toggle="tab" aria-expanded="false" class="nav-link active">Tax</a></li> -->
                            <li class="nav-item"><a href="#report-tax-monitoring-purchasing" data-toggle="tab" aria-expanded="false" class="nav-link active">Purchasing</a></li>
                            <li class="nav-item"><a href="#report-tax-monitoring-purchasing-remaining" data-toggle="tab" aria-expanded="false" class="nav-link">Puchasing Sisa Bulan Kemarin</a></li>
                            <li class="nav-item"><a href="#report-tax-monitoring-sales" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                            <li class="nav-item"><a href="#report-tax-monitoring-sales-remaining" data-toggle="tab" aria-expanded="false" class="nav-link">Sales Sisa Bulan Kemarin</a></li>
                            <!-- <li class="nav-item"><a href="#report-tax-monitoring-purchasing-summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a></li> -->
                            <li class="nav-item"><a href="#report-tax-monitoring-raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
                            <li class="nav-item"><a href="#report-tax-monitoring-sale-order" data-toggle="tab" aria-expanded="false" class="nav-link">Sale Order</a></li>
                            <li class="nav-item"><a href="#report-tax-monitoring-purchasing-order" data-toggle="tab" aria-expanded="false" class="nav-link">Purchasing Order</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="report-tax-monitoring-purchasing">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Purchasing No.</th>
                                    <th>Date</th>
                                    <th>Faktur No.</th>
                                    <th>Faktur Date</th>
                                    <th>Faktur Process Date</th>
                                    <th>Vendor</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Total</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(p, index) in getPurchasing" :key="index">
                                      <td>
                                        <span data-toggle="modal" data-target="#modalTaxMonitoringPurchasingModal" data-backdrop="static" data-keyboard="false" @click="setRefNo(p.ref_no, 'purchasing')" class="text-ref-sales">
                                          {{ p.ref_no }}
                                        </span>
                                      </td>
                                      <td>{{ p.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.faktur_no }}</td>
                                      <td>
                                        <span>{{ p.faktur_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>
                                        <span v-if="p.faktur_process_date < p.date" class="badge badge-danger">{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                        <span v-else-if="p.faktur_date_check === false" class="badge badge-warning">{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                        <span v-else>{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>{{ p.vendor }}</td>
                                      <td class="text-right">{{ p.subtotal | currency }}</td>
                                      <td class="text-right">{{ p.discount | currency }}</td>
                                      <td class="text-right">{{ p.tax | currency }}</td>
                                      <td class="text-right">{{ p.total | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="8" class="text-right">Total Tax</td>
                                      <td class="text-right"><b>{{ totalTaxPurchasing | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8" class="text-right">PPN Masukan</td>
                                      <td class="text-right"><b>{{ totalPPNMasukan | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8" class="text-right">Sisa PPN Masukan</td>
                                      <td class="text-right"><b>{{ totalPPNMasukanRemaining | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-purchasing-remaining">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Type</th>
                                    <th>Purchasing No.</th>
                                    <th>Date</th>
                                    <th>Faktur No.</th>
                                    <th>Faktur Date</th>
                                    <th>Faktur Process Date</th>
                                    <th>Vendor</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Total</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(p, index) in dataSaldo" :key="index">
                                      <td>
                                        <span class="badge badge-success" v-if="p.type === 'purchasing-saldo'">{{ p.type }}</span>
                                        <span class="badge badge-warning" v-else>{{ p.type }}</span>
                                      </td>
                                      <td>{{ p.ref_no }}</td>
                                      <td>{{ p.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.faktur_no }}</td>
                                      <td>{{ p.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.vendor }}</td>
                                      <td class="text-right">{{ p.subtotal | currency }}</td>
                                      <td class="text-right">{{ p.discount | currency }}</td>
                                      <td class="text-right">{{ p.tax | currency }}</td>
                                      <td class="text-right">{{ p.total | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="9" class="text-right"> Total Tax (m-1)</td>
                                      <td class="text-right"><b>{{ totalTaxPurchasingSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="9" class="text-right"> PPN Masukan (m-1)</td>
                                      <td class="text-right"><b>{{ totalPPNMasukanSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="9" class="text-right"> Sisa PPN Masukan (m-1)</td>
                                      <td class="text-right"><b>{{ totalTaxPurchasingSaldo - totalPPNMasukanSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-sales">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Sale No.</th>
                                    <th>Date</th>
                                    <th>Faktur No.</th>
                                    <th>Faktur Date</th>
                                    <th>Faktur Process Date</th>
                                    <th>Customer</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Sales Tax</th>
                                    <th class="text-right">Retur Tax</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Total</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(p, index) in getSales" :key="index">
                                      <td>
                                        <span data-toggle="modal" data-target="#modalTaxMonitoringPurchasingModal" data-backdrop="static" data-keyboard="false" @click="setRefNo(p.ref_no, 'sales')" class="text-ref-sales">
                                          {{ p.ref_no }}
                                        </span>
                                      </td>
                                      <td>{{ p.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.faktur_no }}</td>
                                      <td>
                                        <span>{{ p.faktur_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>
                                        <span v-if="p.faktur_process_date < p.date" class="badge badge-danger">{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                        <span v-else-if="p.faktur_date_check === false" class="badge badge-warning">{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                        <span v-else>{{ p.faktur_process_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>{{ p.customer }}</td>
                                      <td class="text-right">{{ p.subtotal | currency }}</td>
                                      <td class="text-right">{{ p.discount | currency }}</td>
                                      <td class="text-right">{{ p.total_sales_tax | currency }}</td>
                                      <td class="text-right">{{ p.total_retur_tax | currency }}</td>
                                      <td class="text-right">{{ p.tax | currency }}</td>
                                      <td class="text-right">{{ p.total | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="10" class="text-right">Total Tax</td>
                                      <td class="text-right"><b>{{ totalTaxSales | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="10" class="text-right">PPN Keluaran</td>
                                      <td class="text-right"><b>{{ totalPPNKeluaranSale | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="10" class="text-right">Sisa PPN Keluaran</td>
                                      <td class="text-right"><b>{{ totalPPNKeluaranRemaining | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-sales-remaining">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Type</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Faktur No.</th>
                                    <th>Faktur Date</th>
                                    <th>Faktur Process Date</th>
                                    <th>Customer</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Total</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(s, index) in dataSaldoSales" :key="index">
                                      <td>
                                        <span v-if="s.type === 'sales-saldo-null'" class="badge badge-success">{{ s.type }}</span>
                                        <span v-else class="badge badge-warning">{{ s.type }}</span>
                                      </td>
                                      <td>{{ s.ref_no }}</td>
                                      <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ s.faktur_no }}</td>
                                      <td>{{ s.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ s.faktur_process_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ s.customer }}</td>
                                      <td class="text-right">{{ s.subtotal | currency }}</td>
                                      <td class="text-right">{{ s.discount | currency }}</td>
                                      <td class="text-right">{{ s.tax | currency }}</td>
                                      <td class="text-right">{{ s.total | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="9" class="text-right"> Total Tax (m-1)</td>
                                      <td class="text-right"><b>{{ totalTaxSalesSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="9" class="text-right"> PPN Keluaran (m-1)</td>
                                      <td class="text-right"><b>{{ totalPPNKeluaranSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="9" class="text-right"> Sisa PPN Keluaran (m-1)</td>
                                      <td class="text-right"><b>{{ totalTaxSalesSaldo - totalPPNKeluaranSaldo | currency }}</b></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-raw">
                              <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                <i class="fa fa-filter" aria-hidden="true"></i>Filter<span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu p-2" >
                                <span>Type:</span>
                                <div class="dropdown-divider"></div>
                                <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterType" value="purchasing"/> Purchasing</a></li>
                                <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterType" value="sale"/> Sale</a></li>
                                <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterType" value="purchasing-order"/> Purchasing Order</a></li>
                                <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterType" value="sale-order"/> Sale Order</a></li>
                              </ul>
                              <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>Date</th>
                                          <th>Type</th>
                                          <th>Ref No</th>
                                          <th>Customer/Vendor</th>
                                          <th>Faktur No</th>
                                          <th>Tgl. Faktur</th>
                                          <th>Tgl. Process Faktur</th>
                                          <th class="text-right">Subtotal</th>
                                          <th class="text-right">Discount</th>
                                          <th class="text-right">Tax</th>
                                          <th class="text-right">Total</th>
                                      </thead>
                                      <tbody>
                                          <tr v-for="i in filterData" :key="i.id">
                                              <td>{{ i.date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>
                                                  <span v-if="i.type === 'purchasing'" class="badge badge-primary">{{ i.type }}</span>
                                                  <span v-else-if="i.type === 'purchasing-order'" class="badge badge-primary">{{ i.type }}</span>
                                                  <span v-else-if="i.type === 'sale'" class="badge badge-success">{{ i.type }}</span>
                                                  <span v-else-if="i.type === 'sale-order'" class="badge badge-success">{{ i.type }}</span>
                                              </td>
                                              <td>
                                                  <span class="text-ref-sales">
                                                    <span v-if="i.type === 'sale'" @click="showSaleNo(i.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ i.ref_no }}</span>
                                                    <span v-else-if="i.type === 'purchasing'"  @click="showPurchasingNo(i.ref_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ i.ref_no }}</span>
                                                    <span v-else>{{ i.ref_no }}</span>
                                                  </span>
                                              </td>
                                              <td>
                                                <span v-if="i.type === 'purchasing'">{{ i.vendor }}</span>
                                                <span v-else-if="i.type === 'purchasing-order'">{{ i.vendor }}</span>
                                                <span v-else-if="i.type === 'sale'">{{ i.customer }}</span>
                                                <span v-else-if="i.type === 'sale-order'">{{ i.customer }}</span>
                                              </td>
                                              <td>{{ i.faktur_no }}</td>
                                              <td>{{ i.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>{{ i.faktur_process_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td class="text-right">{{ i.subtotal | currency }}</td>
                                              <td class="text-right">{{ i.discount | currency }}</td>
                                              <td class="text-right">{{ i.tax | currency }}</td>
                                              <td class="text-right">{{ i.total | currency }}</td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b>{{ totalTaxRaw | currency }}</b></td>
                                          <td></td>
                                        </tr>
                                      </tfoot>
                                  </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring">
                                <div class="table-responsive">
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>Date</th>
                                            <th class="text-right" style="background-color: #1A1A2E; color: white">Order In</th>
                                            <th class="text-right" style="background-color: #1A1A2E; color: white">In</th>
                                            <th class="text-right" style="background-color: #3d3d75; color: white">Order Out</th>
                                            <th class="text-right" style="background-color: #3d3d75; color: white">Out</th>
                                            <th class="text-right" style="background-color: #6092a3; color: white">Remaining</th>
                                            <th class="text-right" style="background-color: #6092a3; color: white">Order Remaining</th>
                                            <th class="text-right" style="background-color: #6092a3; color: white">Total Remaining</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="g in groupData" :key="g.date">
                                                <td>{{ g.date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td class="text-right">{{ g.taxInOrder | currency }}</td>
                                                <td class="text-right">{{ g.taxIn | currency }}</td>
                                                <td class="text-right">{{ g.taxOutOrder | currency }}</td>
                                                <td class="text-right">{{ g.taxOut | currency }}</td>
                                                <td class="text-right">{{ g.saldo | currency }}</td>
                                                <td class="text-right">{{ g.saldoOrder | currency }}</td>
                                                <td class="text-right">{{ g.saldoTotal | currency }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td class="text-right"><b>{{ totalOrderPPNMasukan | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalPPNMasukan | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalOrderPPNKeluaran | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalPPNKeluaran | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalSaldo | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalSaldoOrder | currency }}</b></td>
                                                <td class="text-right"><b>{{ totalSaldoAll | currency }}</b></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-md-6"><pre>{{ dataRaw }}</pre></div>
                                    <div class="col-md-6"><pre>{{ groupData }}</pre></div>
                                </div> -->
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-purchasing-summary">
                              <div class="table-responsive">
                                <h5>PPN Sisa</h5>
                                <hr/>
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Purchasing No</th>
                                    <th class="text-center">Date</th>
                                    <th class="text-center">Faktur No</th>
                                    <th class="text-center">Faktur Date</th>
                                    <th class="text-center">Faktur Process Date</th>
                                    <th class="text-right">Tax</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(i, index) in getSummaryNull" :key="index">
                                      <td>{{ i.purchasing_no}}</td>
                                      <td class="text-center">{{ i.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-center">{{ i.faktur_no }}</td>
                                      <td class="text-center">{{ i.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-center">{{ i.faktur_process_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-right">{{ i.tax | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td class="text-right" colspan="6"><b>{{ totalSummaryNull | currency }}</b></td>
                                    </tr>
                                  </tfoot>
                                </table>
                                <h5 class="mt-3">PPN Masukan</h5>
                                <hr/>
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Purchasing No</th>
                                    <th class="text-center">Date</th>
                                    <th class="text-center">Faktur No</th>
                                    <th class="text-center">Faktur Date</th>
                                    <th class="text-center">Faktur Process Date</th>
                                    <th class="text-right">Tax</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(i, index) in getSummaryProcess" :key="index">
                                      <td>{{ i.purchasing_no}}</td>
                                      <td class="text-center">{{ i.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-center">{{ i.faktur_no }}</td>
                                      <td class="text-center">{{ i.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-center">{{ i.faktur_process_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td class="text-right">{{ i.tax | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td class="text-right" colspan="6"><b>{{ totalSummaryProcess | currency }}</b></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-sale-order">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Type</th>
                                    <th>Progress</th>
                                    <th>Order No</th>
                                    <th>Order Date</th>
                                    <th>Customer/Vendor</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Tax Progress</th>
                                    <th class="text-right">Tax Outstanding</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(o, index) in saleOrder" :key="index">
                                      <td>
                                        <span class="badge badge-success" v-if="o.type === 'sale-order'">Sale Order</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-success" v-if="o.progress >= 50">{{ o.progress }} %</span>
                                        <span class="badge badge-warning" v-else-if="o.progress < 50">{{ o.progress }} %</span>
                                      </td>
                                      <td>{{ o.order_no }}</td>
                                      <td>{{ o.order_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <span v-if="o.type === 'sale-order'">{{ o.customer }}</span>
                                        <span v-else>{{ o.vendor }}</span>
                                      </td>
                                      <td class="text-right">{{ o.tax | currency }}</td>
                                      <td class="text-right">{{ o.tax_progress | currency }}</td>
                                      <td class="text-right">{{ o.tax_outstanding | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax</td>
                                      <td class="text-right">{{ saleOrderTax | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax Progress</td>
                                      <td class="text-right">{{ saleOrderTaxProgress | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax Outstanding</td>
                                      <td class="text-right">{{ saleOrderTaxOutstanding | currency }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-tax-monitoring-purchasing-order">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Type</th>
                                    <th>Progress</th>
                                    <th>Order No</th>
                                    <th>Order Date</th>
                                    <th>Customer/Vendor</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Tax Progress</th>
                                    <th class="text-right">Tax Outstanding</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(o, index) in purchasingOrder" :key="index">
                                      <td>
                                        <span class="badge badge-info" v-if="o.type === 'purchasing-order'">Purchasing Order</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-success" v-if="o.progress >= 50">{{ o.progress }} %</span>
                                        <span class="badge badge-warning" v-else-if="o.progress < 50">{{ o.progress }} %</span>
                                      </td>
                                      <td>{{ o.order_no }}</td>
                                      <td>{{ o.order_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <span v-if="o.type === 'sale-order'">{{ o.customer }}</span>
                                        <span v-else>{{ o.vendor }}</span>
                                      </td>
                                      <td class="text-right">{{ o.tax | currency }}</td>
                                      <td class="text-right">{{ o.tax_progress | currency }}</td>
                                      <td class="text-right">{{ o.tax_outstanding | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax</td>
                                      <td class="text-right">{{ purchasingOrderTax | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax Progress</td>
                                      <td class="text-right">{{ purchasingOrderTaxProgress | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" class="text-right">Total Tax Outstanding</td>
                                      <td class="text-right">{{ purchasingOrderTaxOutstanding | currency }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchasingModal />
        <SaleModal />
        <TaxSaldoModal />
        <TaxMonitoringModal :taxValue="taxValue" @processFaktur="processFaktur"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import { getHeader, reportUrl, report2Url, journalUrl, purchasingUrl, salesUrl } from '../../config'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import TaxSaldoModal from '@/components/report/TaxSaldoModal.vue'
import TaxMonitoringModal from '@/views/report/TaxMonitoringModal.vue'

export default {
  name: 'ReportTaxMonitoring',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    PurchasingModal,
    SaleModal,
    TaxSaldoModal,
    TaxMonitoringModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      fakturType: null,
      refNo: null,
      taxValue: {
        faktur_no: null,
        faktur_date: null,
        faktur_process_date: null,
        ref_no: null
      },
      dataOrder: [],
      outstandingKeluaran: 0,
      outstandingMasukan: 0,
      dataSaldo: [],
      dataSaldoSales: [],
      paymentPPN: 0,
      filterType: [],
      saldoTax: 0,
      loadingSales: true,
      selected: [],
      startDate: [date1, date2],
      term: 0,
      salesman_id: '',
      company_no: 'C0001',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      taxSaldoList: state => state.taxes.taxSaldoList
    }),
    saleOrder () {
      var array = this.dataOrder.filter(d => d.type === 'sale-order')
      var loop = []
      for (let i = 0; i < array.length; i++) {
        loop.push(array[i])
      }
      return loop
    },
    saleOrderTax () {
      var array = this.saleOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    saleOrderTaxProgress () {
      var array = this.saleOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax_progress)
      }
      return sum
    },
    saleOrderTaxOutstanding () {
      var array = this.saleOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax_outstanding)
      }
      return sum
    },
    purchasingOrder () {
      var array = this.dataOrder.filter(d => d.type === 'purchasing-order')
      var loop = []
      for (let i = 0; i < array.length; i++) {
        loop.push(array[i])
      }
      return loop
    },
    purchasingOrderTax () {
      var array = this.purchasingOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    purchasingOrderTaxProgress () {
      var array = this.purchasingOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax_progress)
      }
      return sum
    },
    purchasingOrderTaxOutstanding () {
      var array = this.purchasingOrder
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax_outstanding)
      }
      return sum
    },
    getSummary () {
      var loop = []
      var array = this.dataRaw.filter(d => d.type === 'purchasing')
      var array2 = this.dataSaldo
      for (let i = 0; i < array.length; i++) {
        var obj = {
          purchasing_no: array[i].ref_no,
          date: array[i].date,
          faktur_no: array[i].faktur_no,
          faktur_date: array[i].faktur_date,
          faktur_process_date: array[i].faktur_process_date,
          tax: array[i].tax
        }
        loop.push(obj)
      }
      for (let b = 0; b < array2.length; b++) {
        var obj2 = {
          purchasing_no: array2[b].ref_no,
          date: array2[b].date,
          faktur_no: array2[b].faktur_no,
          faktur_date: array2[b].faktur_date,
          faktur_process_date: array2[b].faktur_process_date,
          tax: array2[b].tax
        }
        loop.push(obj2)
      }
      var col = 'date'
      var ascending = true
      return loop.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    getSummaryProcess () {
      var array = this.getSummary
      var loop = []
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      for (let i = 0; i < array.length; i++) {
        var fakturDate = new Date(array[i].faktur_process_date).getTime()
        if (fakturDate >= begin) {
          if (fakturDate <= end) {
            loop.push(array[i])
          }
        }
      }
      return loop
    },
    totalSummaryProcess () {
      var sum = 0
      var array = this.getSummaryProcess
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    getSummaryNull () {
      var array = this.getSummary
      var loop = []
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      for (let i = 0; i < array.length; i++) {
        var fakturDate = new Date(array[i].faktur_process_date).getTime()
        if (array[i].faktur_process_date === null) {
          loop.push(array[i])
        }
        if (fakturDate <= begin) {
          if (fakturDate >= end) {
            loop.push(array[i])
          }
        }
        if (fakturDate > end) {
          loop.push(array[i])
        }
      }
      return loop
    },
    totalSummaryNull () {
      var sum = 0
      var array = this.getSummaryNull
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    getPurchasing () {
      var array = this.dataRaw.filter(d => d.type === 'purchasing')
      return array
    },
    getSales () {
      var array = this.dataRaw.filter(d => d.type === 'sale')
      return array
    },
    totalTaxRaw () {
      var array = this.filterData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    totalSaldoTax () {
      var sum = 0
      var array = this.taxSaldoList
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax_saldo)
      }
      return sum
    },
    totalSaldoAllTax () {
      var sum = 0
      sum = this.totalSaldoTax + parseFloat(this.saldoTax)
      return sum
    },
    totalPPNMasukan () {
      var array = this.dataRaw.filter(d => d.type === 'purchasing')
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date === null) {
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate >= begin) {
            if (fakturDate <= end) {
              sum += parseFloat(array[i].tax)
            }
          }
        }
      }
      return sum
    },
    totalPPNKeluaranSale () {
      var array = this.dataRaw.filter(d => d.type === 'sale')
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date === null) {
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate >= begin) {
            if (fakturDate <= end) {
              sum += parseFloat(array[i].tax)
            }
          }
        }
      }
      return sum
    },
    totalTaxPurchasing () {
      var array = this.dataRaw.filter(d => d.type === 'purchasing')
      var sum = 0
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      begin = new Date(begin).getTime()
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date == null) {
          sum += parseFloat(array[i].tax)
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate < begin) {
          } else {
            sum += parseFloat(array[i].tax)
          }
        }
      }
      return sum
    },
    totalTaxSales () {
      var array = this.dataRaw.filter(d => d.type === 'sale')
      var sum = 0
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      begin = new Date(begin).getTime()
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date == null) {
          sum += parseFloat(array[i].tax)
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate < begin) {
          } else {
            sum += parseFloat(array[i].tax)
          }
        }
      }
      return sum
    },
    totalPPNMasukanSaldo () {
      var array = this.dataSaldo
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date === null) {
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate >= begin) {
            if (fakturDate <= end) {
              sum += parseFloat(array[i].tax)
            }
          }
          if (fakturDate < begin) {
            sum += parseFloat(array[i].tax)
          }
        }
      }
      return sum
    },
    totalPPNKeluaranSaldo () {
      var array = this.dataSaldoSales
      var begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      begin = new Date(begin).getTime()
      end = new Date(end).getTime()
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].faktur_process_date === null) {
        } else {
          var fakturDate = new Date(array[i].faktur_process_date).getTime()
          if (fakturDate >= begin) {
            if (fakturDate <= end) {
              sum += parseFloat(array[i].tax)
            }
          }
          if (fakturDate < begin) {
            sum += parseFloat(array[i].tax)
          }
        }
      }
      return sum
    },
    totalTaxPurchasingSaldo () {
      var array = this.dataSaldo
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    totalTaxSalesSaldo () {
      var array = this.dataSaldoSales
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax)
      }
      return sum
    },
    totalPPNMasukanRemaining () {
      var sum = this.totalTaxPurchasing - this.totalPPNMasukan
      return sum
    },
    totalPPNKeluaranRemaining () {
      var sum = this.totalTaxSales - this.totalPPNKeluaranSale
      return sum
    },
    totalAllPPNMasukanRemaning () {
      var sum = this.totalPPNMasukanRemaining + this.totalTaxPurchasingSaldo - this.totalPPNMasukanSaldo
      return sum
    },
    totalAllPPNKeluaranRemaning () {
      var sum = this.totalPPNKeluaranRemaining + this.totalTaxSalesSaldo - this.totalPPNKeluaranSaldo
      return sum
    },
    totalPPNKeluaran () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].taxOut)
      }
      return sum
    },
    totalAllPPNbyDate () {
      var sum = 0
      sum = this.totalPPNMasukan - this.totalPPNKeluaran
      return sum
    },
    totalAllPPN () {
      var sum = 0
      if (parseFloat(this.totalAllPPNbyDate) <= 0) {
        sum = (this.totalSaldoTax + this.saldoTax) + this.totalAllPPNbyDate
      } else {
        sum = (this.totalSaldoTax + this.saldoTax) - this.totalAllPPNbyDate
      }
      // this.totalPPNMasukan - this.totalPPNKeluaran
      return sum
    },
    totalOrderPPNMasukan () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].taxInOrder)
      }
      return sum
    },
    totalOrderPPNKeluaran () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].taxOutOrder)
      }
      return sum
    },
    totalAllOrderPPN () {
      var sum = 0
      sum = this.totalOrderPPNMasukan - this.totalOrderPPNKeluaran
      return sum
    },
    totalSaldo () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    totalSaldoOrder () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldoOrder)
      }
      return sum
    },
    totalSaldoAll () {
      var array = this.groupData
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldoTotal)
      }
      return sum
    },
    groupData () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          var key = value.date
          var taxIn = 0
          var taxOut = 0
          var taxInOrder = 0
          var taxOutOrder = 0
          var inColl = []
          var outColl = []
          var saldoTotal = 0
          var saldo = 0
          var saldoOrder = 0
          if (value.type === 'purchasing') {
            taxIn = parseFloat(value.tax)
            inColl.push({
              ref_no: value.ref_no,
              subtotal: value.subtotal,
              discount: value.discount,
              tax: value.tax,
              total: value.total
            })
          } else if (value.type === 'purchasing-order') {
            taxInOrder += parseFloat(value.tax)
          } else if (value.type === 'sale') {
            taxOut = parseFloat(value.tax)
            outColl.push({
              ref_no: value.ref_no,
              subtotal: value.subtotal,
              discount: value.discount,
              tax: value.tax,
              total: value.total
            })
          } else if (value.type === 'sale-order') {
            taxOutOrder += parseFloat(value.tax)
          }
          saldo = taxIn - taxOut
          saldoOrder = taxInOrder - taxOutOrder
          saldoTotal = saldo + saldoOrder
          if (!res[key]) {
            res[key] = {
              date: value.date,
              taxIn: taxIn,
              taxInOrder: taxInOrder,
              in: inColl,
              taxOut: taxOut,
              taxOutOrder: taxOutOrder,
              out: outColl,
              saldo: saldo,
              saldoOrder: saldoOrder,
              saldoTotal: saldoTotal
            }
            result.push(res[key])
          } else {
            res[key].taxIn = parseFloat(res[key].taxIn) + taxIn
            res[key].taxInOrder = parseFloat(res[key].taxInOrder) + taxInOrder
            res[key].taxOut = parseFloat(res[key].taxOut) + taxOut
            res[key].taxOutOrder = parseFloat(res[key].taxOutOrder) + taxOutOrder
            res[key].saldo = parseFloat(res[key].saldo) + saldo
            res[key].saldoOrder = parseFloat(res[key].saldoOrder) + saldoOrder
            res[key].saldoTotal = parseFloat(res[key].saldoTotal) + saldoTotal
          }
          return res
        }, {})
      }
      return result
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      })
    }
  },
  methods: {
    async setRefNo (value, type) {
      this.refNo = value
      this.fakturType = type
      if (type === 'purchasing') {
        var obj = {
          purchasing: value
        }
        await axios.post(purchasingUrl + '/get-purchasing-no', obj, { headers: getHeader() })
          .then(response => {
            const data = response.data.data
            console.log(data)
            this.taxValue = {
              faktur_no: data.faktur_no,
              faktur_date: data.faktur_date,
              faktur_process_date: data.faktur_process_date,
              ref_no: data.purchasing_no
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      } else if (type === 'sales') {
        var objSales = {
          sale_no: this.refNo
        }
        await axios.post(salesUrl + '/get-sale-no', objSales, { headers: getHeader() })
          .then(response => {
            const data = response.data.data
            console.log(data)
            this.taxValue = {
              faktur_no: data.faktur_no,
              faktur_date: data.faktur_date,
              faktur_process_date: data.faktur_process_date,
              ref_no: data.sale_no
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
    },
    async processFaktur (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      console.log(this.fakturType)
      console.log(this.refNo)
      console.log(value)
      if (this.fakturType === 'purchasing') {
        var obj = {
          faktur_no: value.faktur_no,
          faktur_date: value.faktur_date,
          faktur_process_date: value.faktur_process_date,
          purchasing_no: this.refNo
        }
        await axios.post(purchasingUrl + '/set-faktur', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.fakturType = null
            this.refNo = null
            this.taxValue = {
              faktur_no: null,
              faktur_date: null,
              faktur_process_date: null,
              ref_no: null
            }
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Purchasing Tax', error.response.data.message, 'error')
            this.fakturType = null
            this.refNo = null
            this.taxValue = {
              faktur_no: null,
              faktur_date: null,
              faktur_process_date: null,
              ref_no: null
            }
            this.$Progress.fail()
            this.loader.isLoading = false
            throw error
          })
      } else if (this.fakturType === 'sales') {
        var objSales = {
          faktur_no: value.faktur_no,
          faktur_date: value.faktur_date,
          faktur_process_date: value.faktur_process_date,
          sale_no: this.refNo
        }
        await axios.post(salesUrl + '/set-faktur', objSales, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.fakturType = null
            this.refNo = null
            this.taxValue = {
              faktur_no: null,
              faktur_date: null,
              faktur_process_date: null,
              ref_no: null
            }
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Purchasing Tax', error.response.data.message, 'error')
            this.fakturType = null
            this.refNo = null
            this.taxValue = {
              faktur_no: null,
              faktur_date: null,
              faktur_process_date: null,
              ref_no: null
            }
            this.$Progress.fail()
            this.loader.isLoading = false
            throw error
          })
      }
      await this.refreshList()
    },
    async getJournalPPN () {
      const date = this.startDate[0] ? (this.startDate[0].getMonth() + 1) + '/' + this.startDate[0].getFullYear() : null
      var obj = {
        date: date,
        company_no: this.company_no
      }
      console.log('getJournalPPN')
      console.log(obj)
      await axios.post(journalUrl + '/get-journal-ppn', obj, { headers: getHeader() })
        .then(response => {
          this.paymentPPN = response.data.data
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    getSaldo () {
      var date = new Date()
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      var payload = {
        begin: begin,
        end: end,
        company: this.company_no
      }
      console.log(payload)
      this.$store.dispatch('getTaxSaldoList', payload)
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(reportUrl + '/tax-monitoring')
      await axios.post(reportUrl + '/tax-monitoring', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.dataSaldo = response.data.dataSaldo
          this.dataSaldoSales = response.data.dataSaldoSales
          this.saldoTax = response.data.taxSaldo
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var obj2 = {
        begin: null,
        end: end,
        company_no: this.company_no
      }
      await axios.post(reportUrl + '/tax-monitoring-outstanding', obj2, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          console.log(response.data.data)
          this.outstandingMasukan = response.data.data.outstanding_masukan
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.getSaldo()
      await this.getJournalPPN()
      await this.getOrder()
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async getOrder () {
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: '2022-01-01',
        end: end,
        company_no: this.company_no
      }
      axios.post(reportUrl + '/tax-monitoring-order', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataOrder = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (format, type) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        format: format,
        type: type,
        purchasings: this.getPurchasing,
        sales: this.getSales,
        dataSaldo: this.dataSaldo,
        dataSaldoSales: this.dataSaldoSales,
        totalTaxPurchasing: this.totalTaxPurchasing,
        totalPPNMasukan: this.totalPPNMasukan,
        totalPPNMasukanRemaining: this.totalPPNMasukanRemaining,
        totalTaxPurchasingSaldo: this.totalTaxPurchasingSaldo,
        totalPPNMasukanSaldo: this.totalPPNMasukanSaldo,
        totalTaxSales: this.totalTaxSales,
        totalPPNKeluaranSale: this.totalPPNKeluaranSale,
        totalPPNKeluaranRemaining: this.totalPPNKeluaranRemaining,
        totalTaxSalesSaldo: this.totalTaxSalesSaldo,
        totalPPNKeluaranSaldo: this.totalPPNKeluaranSaldo,
        begin: begin,
        end: end
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/tax-monitoring', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
